import React, { useEffect, useState } from "react";
import moment from "moment";
import { Button, Alert, Box, ComboBox, Input, Row, Label, Col } from "@intech/web-ui";
import { FichaFinanceiraEntidade, PlanoVinculadoEntidade, SaldoContribuicoesFaelceEntidade } from "@entidades";
import { FichaFinanceiraService } from "@services";
import NumberFormat from "react-number-format";
import { SaldoAcomulado } from "./SaldoAcumulado";
import { ExtratoDetalhado } from "./ExtratoDetalhado";
import { Beneficiarios, LoadingComponent } from "@components";
import { HomeCard } from "@screens/Home/HomeCard/HomeCard";
import { Informativos } from "./Informativos";
import { ComboRefItem } from "..";
// import { Contribuicoes } from './Contribuicoes';

interface IProps {
  plano: PlanoVinculadoEntidade | null;
}

export const PlanoItemBD: React.FC<IProps> = ({ plano }) => {
  const [AlertText, setAlertText] = useState<string>("");
  const [Loading, setLoading] = useState<boolean>(true);
  const [ComboRef, setComboRef] = useState<Array<ComboRefItem>>(new Array<ComboRefItem>());
  const [Referencia, setReferencia] = useState<string>("");
  const [ReferenciaDefault, setReferenciaDefault] = useState<string>("");
  const [Periodo, setPeriodo] = useState<number>(999);
  const [TextoPeriodo, setTextoPeriodo] = useState<string>("");
  const [Saldo, setSaldo] = useState<SaldoContribuicoesFaelceEntidade | undefined>(undefined);
  const [Detalhes, setDetalhes] = useState<Array<FichaFinanceiraEntidade>>(new Array<FichaFinanceiraEntidade>());

  const ComboPeriodo = [
    {
      Key: 999,
      Name: "TODOS OS MESES",
    },
    {
      Key: 3,
      Name: "3 MESES",
    },
    {
      Key: 6,
      Name: "6 MESES",
    },
    {
      Key: 12,
      Name: "12 MESES",
    },
  ];

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        if (plano !== null) {
          const ultimaContribuicao = await FichaFinanceiraService.BuscarContribuicao(plano.CD_PLANO);
          const Detalhes = await FichaFinanceiraService.BuscarDetalhamento(
            plano!.CD_PLANO,
            Periodo,
            ultimaContribuicao[0].ANO_COMP,
            ultimaContribuicao[0].MES_COMP
          );

          if (plano.CD_PLANO === "0001") {
            const ComboRef: ComboRefItem[] = [];

            let data_ref = moment();
            let data_final = moment("01/" + Detalhes[Detalhes.length - 1].MES_COMP + "/" + Detalhes[Detalhes.length - 1].ANO_COMP, "DD/MM/YYYY");

            while (data_ref.isAfter(data_final)) {
              const Item: ComboRefItem = {
                Key: data_ref.format("MM/YYYY"),
                Name: data_ref.format("MM/YYYY"),
              };
              ComboRef.push(Item);
              data_ref.subtract(1, "month");
            }

            setComboRef(ComboRef);

            setReferencia(ComboRef[0].Key);

            // setReferenciaDefault(ultimaContribuicao[0].MES_COMP + "/" + ultimaContribuicao[0].ANO_COMP);
          }
        }
        setLoading(false);
      } catch (e) {
        const error = e.response ? e.response.data : e;
        setAlertText(error);
        setLoading(false);
      }
    })();
  }, []);

  async function ConsultarExtrato() {
    try {
      setAlertText("");
      setSaldo(undefined);
      setDetalhes(new Array<FichaFinanceiraEntidade>());

      const Format = "DD/MM/yyyy";
      const DataNova = moment("01/" + Referencia, Format);
      const DataAntiga = moment("01/" + ReferenciaDefault, Format);

      if (!DataNova.isValid()) {
        setAlertText("Referência Inválida.");
        return null;
      }

      // if (DataNova.isAfter(DataAntiga)) {
      //   setAlertText(`Referência não pode ser maior que ${ReferenciaDefault}`);
      //   return null;
      // }

      const ref = Referencia.split("/");
      const Saldo = await FichaFinanceiraService.BuscarSaldoContribuicoesPorReferencia(plano!.CD_PLANO, ref[1], ref[0]);

      setSaldo(Saldo);

      const Detalhes = await FichaFinanceiraService.BuscarDetalhamento(plano!.CD_PLANO, Periodo, ref[1], ref[0]);
      setDetalhes(Detalhes);

      setTextoPeriodo(ComboPeriodo.find((x) => x.Key == Periodo)?.Name!);
    } catch (e) {
      const error = e.response ? e.response.data : e;
      setAlertText(error);
    }
  }

  async function gerarRelatorio() {
    try {
      setAlertText("");

      const Format = "DD/MM/yyyy";
      const DataNova = moment("01/" + Referencia, Format);
      const DataAntiga = moment("01/" + ReferenciaDefault, Format);

      if (!DataNova.isValid()) {
        setAlertText("Referência Inválida.");
        return null;
      }

      // if (DataNova.isAfter(DataAntiga)) {
      //   setAlertText(`Referência não pode ser maior que ${ReferenciaDefault}`);
      //   return null;
      // }

      const ref = Referencia.split("/");
      var relatorio = await FichaFinanceiraService.GerarRelatorioExtratoBD(plano!.CD_PLANO, Periodo, ref[1], ref[0], false);

      if (navigator.msSaveBlob) {
        // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(new Blob([relatorio]), "extrato.pdf");
      } else {
        const url = window.URL.createObjectURL(new Blob([relatorio]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "extrato.pdf");
        document.body.appendChild(link);
        link.click();
      }
    } catch (e) {
      const error = e.response ? e.response.data : e;
      console.log(error);
      setAlertText(error);
    }
  }

  if (Loading) {
    return <LoadingComponent />;
  }

  return (
    <>
      <Box>
        <div className="mb-3">
          <ComboBox value={Referencia} title={"Referência"} data={ComboRef} onChange={setReferencia} memberName={"Name"} memberValue={"Key"} />
        </div>

        {/* <div className="form-group" >
          <Row>
            <Label
              value={"Referência"}
            />

            <Col>
              <div>
                <NumberFormat
                  className="form-control"
                  format="##/####"
                  mask="_"
                  value={Referencia}
                  onChange={(e) => setReferencia(e.target.value)}
                />
              </div>
            </Col>
          </Row>
        </div> */}

        <div className="mb-3">
          <ComboBox value={Periodo} title={"Período"} data={ComboPeriodo} onChange={setPeriodo} memberName={"Name"} memberValue={"Key"} />
        </div>

        {AlertText !== "" && <Alert type={"danger"}>{AlertText}</Alert>}

        <Button onClick={ConsultarExtrato} title={"Consultar Extrato"} type={"primary"} loadingText={"Buscando..."} usesLoading block />

        <Button onClick={gerarRelatorio} title={"Gerar Extrato em PDF"} type={"primary"} loadingText={"Baixando..."} usesLoading block />
      </Box>

      {Saldo !== undefined && (
        <>
          <Row>
            <Col>
              <HomeCard titulo={plano!.DS_PLANO} subTitulo={`CNPB: ${plano!.COD_CNPB}`}>
                {plano!.DS_CATEGORIA}
              </HomeCard>
            </Col>
          </Row>

          <SaldoAcomulado referencia={Referencia} saldo={Saldo} />

          <Beneficiarios />

          <Informativos />

          <ExtratoDetalhado Detalhes={Detalhes} />
        </>
      )}
    </>
  );
};
